import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppHeader } from "@/components/app-header";

import { UserProvider } from "../../context/user-provider";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ context, location }) => {
    // If Auth0 reports the user isn't logged in, redirect them
    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: "/sign-in",
        search: {
          // Store the intended path to redirect back after logging in
          redirect: location.href,
        },
      });
    }
  },
  component: () => (
    <UserProvider>
      <div className="flex min-h-160 flex-col bg-background pb-6">
        <AppHeader />
        <main className="mx-auto max-w-360 w-full px-4 md:px-6 py-6">
          <Outlet />
        </main>
      </div>
    </UserProvider>
  ),
});
